import { ACADEMIC_CALENDAR_2026 } from '../data/academicCalendar2026'
import { COURSE_REGISTRATION_SCHEDULE } from '../data/courseRegistrationSchedule'

// Notification term is the published live term, never the viewed timetable.
export function notificationScope(uid = null, semesterKey = COURSE_REGISTRATION_SCHEDULE.semesterKey) {
 if (!/^\d{4}-(1|2|S|W)$/.test(semesterKey ?? '')) throw Error('invalid_notification_semester')
 return { uid: uid || null, semesterKey }
}
export const scopeKey = scope => JSON.stringify([scope?.uid || 'guest', scope?.semesterKey || 'unscoped'])
export function notificationOwnerKey(scope) {
 // Opaque ownership marker: raw account IDs are not written to OS notification metadata.
 let hash = 2166136261, second = 5381
 for (const char of scopeKey(scope)) { hash = Math.imul(hash ^ char.charCodeAt(0), 16777619); second = Math.imul(second, 33) ^ char.charCodeAt(0) }
 return (hash >>> 0).toString(16).padStart(8, "0") + (second >>> 0).toString(16).padStart(8, "0")
}
export function occursInNotificationSemester(dateString, scope) {
 if (!scope) return true // pure legacy callers; production always supplies an explicit scope
 const [year, term] = scope.semesterKey.split('-')
 const calendar = ACADEMIC_CALENDAR_2026.filter(row => String(row.academicYear) === year)
 if (term === '1' || term === '2') {
  const start = calendar.find(row => row.category === 'semester_start' && row.term === `${term}학기`)
  const end = calendar.find(row => row.category === 'vacation' && row.term === (term === '1' ? '하계' : '동계'))
  // Never invent dates for an unpublished semester/calendar.
  return Boolean(start && end && dateString >= start.startDate && dateString < end.startDate)
 }
 const seasonal = calendar.find(row => row.category === 'seasonal_semester' && row.term === (term === 'S' ? '하계' : '동계') && row.startDate.startsWith(year))
 return Boolean(seasonal && dateString >= seasonal.startDate && dateString <= seasonal.endDate)
}
export const notificationFireTime = notification => Number.isFinite(notification?.extra?.fireAt) ? notification.extra.fireAt : new Date(notification?.schedule?.at).getTime()

export function scopeNotification(candidate, scope, hashId, eventId, occurrenceAt, offsetMinutes) {
 if (!scope) return candidate
 const owner = notificationOwnerKey(scope)
 const logicalKey = JSON.stringify([owner, scope.semesterKey, candidate.extra.kind, String(eventId), occurrenceAt, offsetMinutes])
 return { ...candidate, id: hashId(logicalKey), extra: { ...candidate.extra,
  owner: 'suguide', version: 2, fireAt: candidate.schedule.at.getTime(), ownerKey: owner, semesterKey: scope.semesterKey, logicalKey,
  contentKey: JSON.stringify([candidate.title, candidate.body, candidate.sound, candidate.interruptionLevel, candidate.isExactNotification]),
 } }
}
